import Description from "@/pages/quiz/base/questions/disclaimerAcknowledgment/components/Description";
import {
  DisclaimerCheckboxName,
  getDisclaimersData,
  DisclaimerValue,
} from "@/pages/quiz/base/questions/disclaimerAcknowledgment/common";
import { DisclaimerItem } from "@/pages/quiz/base/questions/disclaimerAcknowledgment/components/DisclaimerItem";
import { Button } from "@/components/common/button";
import { useGetIsYounger64 } from "@/pages/quiz/base/hooks/useGetIs64OrOver";
import {useGetGender} from "@/pages/quiz/base/hooks/useGetGender";

type QuizQuestionProps<T> = {
  questionValue: T;
  setQuestionValue: (value: T) => void;
  setQuestionAnswer: (value: boolean) => void; // Ensure this is correct
};

const DisclaimerAcknowledgmentQuestion = ({
  questionValue,
  setQuestionValue,
  setQuestionAnswer,
}: QuizQuestionProps<DisclaimerValue>) => {
  const isYounger64 = useGetIsYounger64();
  const { isMale } = useGetGender();

  const onChange = (name: DisclaimerCheckboxName) => {
    const newValues = { ...questionValue, [name]: !questionValue?.[name] };
    setQuestionValue(newValues);
  };

  const isDisableButton =
    !questionValue.pregnancy ||
    !questionValue.telehealthConsent ||
    !questionValue.sideEffects;

  return (
    <div className="flex flex-col justify-center">
      <p className="section-title">
        Please review and agree to the following precautions
      </p>
      <div className="space-y-4">
        <Description
          description={
            "Read the following for more information about this product and its potential side effects."
          }
        />

        {getDisclaimersData(isYounger64, isMale).map((disclaimerData, idx) => (
          <DisclaimerItem
            key={idx}
            checked={questionValue[disclaimerData.name] || false}
            onChange={onChange}
            disclaimerData={disclaimerData}
          />
        ))}
      </div>

      <Button
        disabled={isDisableButton}
        onClick={() => setQuestionAnswer(true)} // Ensure this matches the type definition
      />
    </div>
  );
};

export { DisclaimerAcknowledgmentQuestion };
